// 검차 셸 상단 바 — SimpleShell 과 차량관리 크롬(SimpleChrome)이 같은 마크업을 쓴다 (SimpleShell.js 에서 그대로 이동).
// ≥1024: 로고 · 탭 · 회사 드롭다운 / 769~1023: 로고 · 탭 · 언어 · 회사 / ≤768: 얇은 상단 바(로고 · 언어) — 탭은 하단 BottomTabs.
// props: { user, screenMode, onLogout, tabs: [{ id, label, onClick }], activeTab, isMobile, isDesktop, extra }
//   extra = 오른쪽 끝 앞에 끼우는 노드 (차량관리 크롬의 오류 신고 버튼)
//   who   = 데스크톱 회사명 메뉴 교체 노드 (말소 셸의 MalsoWhoMenu) — 없으면 WhoMenu
import React from 'react';
import LangSelect from './LangSelect';
import WhoMenu, { initialsOf } from './WhoMenu';

function SimpleAppBar(props) {
  var user = props.user || {};
  var companyName = user.companyNameEn || user.companyName || user.name || '';
  var tabs = props.tabs || [];
  var activeTab = props.activeTab;
  var isMobile = props.isMobile;
  var isDesktop = props.isDesktop;

  return isMobile ? (<header className="ss-mtop">
      <span className="ss-logo">AUTODEX</span>
      <span style={{ flex: 1 }} />
      {props.extra}
      <LangSelect />
    </header>) : (<header className="ss-appbar">
      <span className="ss-logo">AUTODEX</span>
      <nav className="ss-tabs">
        {tabs.map(function (tab) {
          return (<button key={tab.id} type="button" data-tab={tab.id}
            className={'ss-tab' + (tab.id === activeTab ? ' on' : '')}
            aria-current={tab.id === activeTab ? 'page' : undefined}
            onClick={tab.onClick}>{tab.label}</button>);
        })}
      </nav>
      <div className="ss-right">
        {props.extra}
        {isDesktop ? (props.who || <WhoMenu user={user} screenMode={props.screenMode} onLogout={props.onLogout} />) : (<React.Fragment>
          <LangSelect />
          <span className="ss-who">
            <span className="ss-av">{initialsOf(companyName)}</span>
            <span dir="ltr">{companyName}</span>
          </span>
        </React.Fragment>)}
      </div>
    </header>);
}

export default SimpleAppBar;
